import { LOCATION_CHANGE } from 'connected-react-router';

import { RECEIVE_UTILITY } from '../product/product-actions';
import {
    ADD_TO_CART,
    UPDATE_CART,
    RECENTLY_ADDED,
    CLEAR_RECENTLY_ADDED,
    REMOVE_FROM_CART,
    LAUNCH_CART_FLYOUT,
    CLOSE_CART_FLYOUT,
    REFRESH_CART,
    SET_CART_VIEW,
    SET_CART_DETAILS,
    SET_CTO_VERIFICATION,
    SET_CART_AJAX_ERROR,
    CLEAR_CART_AJAX_ERROR,
    SET_DISABLE_CART_ACTION,
} from './utility-actions';

const NULL_STATE = {
    items: [],
    addToCartFlyoutVisible: false,
    labels: {
        add2Cart: 'Add to cart',
        cartSubtotal: 'Sub-total',
        mcchq: 'QTY',
        cartCheckout: 'Checkout',
        comingSoon: 'Coming soon',
        emptyCart: 'There are no items in your cart',
        cartTaxFee: 'before tax & fees',
        poboShipMsg: 'Ships by',
        cartView: 'view cart & check out',
        invOutOfStock: 'Out of stock',
        add2Quote: 'Add to quote',
        customizeOnlyBtn: 'Customize',
        backOrder: 'Back-order',
        invLeft: 'Left!',
        preOrder: 'Pre-order',
        addMsg: 'Just added to cart',
        viewSupplies: 'View supplies',
        cartTxt: 'View all items',
        customizeBtn: 'Customize & buy',
    },
};

const CartReducer = (state = NULL_STATE, action) => {
    Object.freeze(state);
    switch (action.type) {
        case RECEIVE_UTILITY:
            return Object.assign({ updatedFromService: true }, state, action.utilityInfo.cartData);
        case REFRESH_CART:
            return Object.assign({}, state, action.cartData);
        case ADD_TO_CART:
            return Object.assign({}, state, action.cartData);
        case RECENTLY_ADDED:
            const { product, addToCartResponse, options } = action;
            return Object.assign({}, state, { recentlyAdded: { product, addToCartResponse, options } });
        case CLEAR_RECENTLY_ADDED:
            return Object.assign({}, state, { recentlyAdded: undefined });
        case UPDATE_CART:
            return Object.assign({}, state, action.cartData);
        case REMOVE_FROM_CART:
            return Object.assign({}, state, action.cartData);
        case LAUNCH_CART_FLYOUT:
            const { analyticsData } = (action && action.payload) || {};
            return Object.assign({}, state, { addToCartFlyoutVisible: true, analyticsData });
        case SET_DISABLE_CART_ACTION:
            return Object.assign({}, state, { disableCartAction: action.disableCartAction });
        case SET_CART_VIEW:
            //overwrite lastUpdateDate to force a refresh, since API doesnt alays update it
            const lastUpdateDate = new Date().getTime();
            return Object.assign({}, state, { cartView: { ...action.cartView, lastUpdateDate } });
        case SET_CART_DETAILS:
            return Object.assign({}, state, { cartDetails: action.cartDetails });
        case SET_CTO_VERIFICATION:
            return Object.assign({}, state, { ctoVerification: action.ctoVerification });
        case LOCATION_CHANGE:
            const { payload } = action;
            const { location } = payload || {};
            const { pathname } = location || {};
            return Object.assign({}, state, {
                addToCartFlyoutVisible: false,
                analyticsData: null,
                recentlyAdded: undefined,
                //if leaving cart page, clear cart view and details
                ...(!(pathname || '').includes('cart')
                    ? {
                          cartView: undefined,
                          cartDetails: undefined,
                      }
                    : {}),
            });
        case CLOSE_CART_FLYOUT:
            return Object.assign({}, state, { addToCartFlyoutVisible: false, analyticsData: null });
        case SET_CART_AJAX_ERROR:
            const { ajaxError } = action;
            const { ajaxError: currentAjaxError } = state;
            //if existing ajax error, add new one to the top. then remove duplicates
            const newState = currentAjaxError?.length > 0 ? [ajaxError, ...(state.ajaxError || [])] : [ajaxError];
            return Object.assign({}, state, {
                ajaxError: newState.filter(
                    (error, index) => newState.findIndex(e => e.message === error.message) === index,
                ),
            });
        case CLEAR_CART_AJAX_ERROR:
            const { ajaxError: ajaxErrorStateArray, errorClass } = state;
            if (ajaxErrorStateArray?.length === 0) {
                return state;
            }
            if (errorClass) {
                return Object.assign({}, state, {
                    ajaxError: state.ajaxError.filter(error => error.errorClass !== errorClass),
                });
            }
            return Object.assign({}, state, { ajaxError: [] });
        default:
            return state;
    }
};

export default CartReducer;
